import React from "react";
import { useEffect, useState } from "react";



function ZoneOrb(props) {
  
  const [intervalId, setIntervalId] = useState(0);

  var SCREEN_WIDTH = props.size;
  var SCREEN_HEIGHT = props.size;
  var mouseX = SCREEN_WIDTH * 0.5;
  var mouseY = SCREEN_HEIGHT * 0.5;
  var mouseIsDown = false;

  var RADIUS = 70;
  RADIUS = props.size/2;

  var RADIUS_SCALE = 1;
  var RADIUS_SCALE_MIN = 1;
  var RADIUS_SCALE_MAX = 1.5;

  var QUANTITY = 25;

  var canvas;
  var context;
  var particles;



  useEffect(() => { 

    canvas = document.getElementById('world');

    if (canvas && canvas.getContext) {
      context = canvas.getContext('2d');


      createParticles();
      canvas.width = SCREEN_WIDTH;
      canvas.height = SCREEN_HEIGHT;

      clearInterval(intervalId);
      let id = setInterval(loop, 1000 / 60);
      setIntervalId(id);
    }
  }, [props.fillColor]);


  function createParticles() {
    particles = [];

    console.log('#' + (Math.random() * 0x404040 + 0xaaaaaa | 0).toString(16));

    for (var i = 0; i < QUANTITY; i++) {
      var particle = {
        size: 1,
        position: { x: mouseX, y: mouseY },
        offset: { x: 0, y: 0 },
        shift: { x: mouseX, y: mouseY },
        speed: 0.01 + Math.random() * 0.04,
        targetSize: 1,
        fillColor: props.fillColor,
        orbit: RADIUS * .5 + (RADIUS * .5 * Math.random())
      };

      particles.push(particle);
    }
  }

  function loop() {

    if (mouseIsDown) {
      RADIUS_SCALE += (RADIUS_SCALE_MAX - RADIUS_SCALE) * (0.02);
    }
    else {
      RADIUS_SCALE -= (RADIUS_SCALE - RADIUS_SCALE_MIN) * (0.02);
    }

    RADIUS_SCALE = Math.min(RADIUS_SCALE, RADIUS_SCALE_MAX);

    context.fillStyle = 'rgba(0,0,0,0.05)';
    context.fillRect(0, 0, context.canvas.width, context.canvas.height);

    for (let i = 0; i < particles.length; i++) {
      var particle = particles[i];

      var lp = { x: particle.position.x, y: particle.position.y };

      // Rotation
      particle.offset.x += particle.speed;
      particle.offset.y += particle.speed;

      // Follow mouse with some lag
      particle.shift.x += (mouseX - particle.shift.x) * (particle.speed);
      particle.shift.y += (mouseY - particle.shift.y) * (particle.speed);

      // Apply position
      particle.position.x = particle.shift.x + Math.cos(i + particle.offset.x) * (particle.orbit * RADIUS_SCALE);
      particle.position.y = particle.shift.y + Math.sin(i + particle.offset.y) * (particle.orbit * RADIUS_SCALE);

      // Limit to screen bounds
      particle.position.x = Math.max(Math.min(particle.position.x, SCREEN_WIDTH), 0);
      particle.position.y = Math.max(Math.min(particle.position.y, SCREEN_HEIGHT), 0);

      particle.size += (particle.targetSize - particle.size) * 0.05;

      if (Math.round(particle.size) == Math.round(particle.targetSize)) {
        particle.targetSize = 1 + Math.random() * 7;
      }

      context.beginPath();
      context.fillStyle = particle.fillColor;
      context.strokeStyle = particle.fillColor;
      context.lineWidth = particle.size;
      context.moveTo(lp.x, lp.y);
      context.lineTo(particle.position.x, particle.position.y);
      context.stroke();
      context.arc(particle.position.x, particle.position.y, particle.size / 2, 0, Math.PI * 2, true);
      context.fill();
    }
  }

  return <div style={{ width: "98%", magrin: "1%", padding: "10px", display: "flex", flexDirection: "row", justifyContent: "center" }}>
    <canvas id='world' width='300px' height='300px'></canvas>
  </div>;



}



export default ZoneOrb;
